import initialState from '../store/initial-state'
import {
  SHOW_COMMENT,
  HIDE_COMMENT,
  COMMENT_EMPTY,
  GET_COMMENT,
  GET_COMMENT_SUCCESS,
  GET_COMMENT_FAILURE,
  UPDATE_COMMENT_DART,
  LOADING_COMMENT_DART,
  LOADING_COMMENT_DART_ERROR,
  GET_COMMENTS,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAILURE,
  ADD_COMMENT,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILURE,
  SHOW_LIST_COMMENTS,
  HIDE_LIST_COMMENTS,
  DELETE_COMMENT,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  UPDATE_COMMENT_SUCCESS,
  SUCCESS_COMMENT_DETERMINED,
  SAVE_COMMENT_DETERMINED,
  SAVE_COMMENT_DETERMINED_SUCCESS,
  SAVE_COMMENT_DETERMINED_FAILURE,
  DELETE_COMMENT_DETERMINED,
  DELETE_COMMENT_DETERMINED_SUCCESS,
  SHOW_BUTTON_COMMENTS,
  HIDE_BUTTON_COMMENTS,
  SEARCH_COMMENTS,
  SHOW_COMPARE_VERSIONS,
  HIDE_COMPARE_VERSIONS,
  SET_VERSIONS_COMPARE,
  SEARCH_COMMENTS_SUCCESS,
  SEARCH_COMMENTS_CLEAR,
  SET_IS_EMPTY_COMPARE_DATA,
  SHOW_VERSIONS,
  HIDE_VERSIONS,
  DELETE_VERSIONS,
  DELETE_VERSIONS_SUCCESS,
  SET_QTY_VERSIONS,
  SHOW_BUTTON_EMOJI,
  HIDE_BUTTON_EMOJI,
  SET_SOCKET_COMMENT_SCROLL,
  CLEAR_LAST_COMMENTS,
  RESET_STATUS_ASSET,
  CLEAR_FOCUS_DESCRIPTION,
  GET_USERS_TO_COMMENT,
  GET_USERS_TO_COMMENT_FAILURE,
  GET_USERS_TO_COMMENT_SUCCESS,
  CLEAN_USERS_TO_COMMENT,
  SET_IS_DOING_A_COMMENT_WITH_FILE,
  UNSET_IS_DOING_A_COMMENT_WITH_FILE,
  SET_PDF_CARROUSEL_INDEX,
  GET_PDF_PAGES,
  GET_PDF_PAGES_SUCCESS,
  GET_PDF_PAGES_FAILURE,
  SET_IS_PDF_TAG_ACTIVE,
  UNSET_IS_PDF_TAG_ACTIVE,
  SET_PDF_TAG_CLICKED,
  UNSET_PDF_TAG_CLICKED,
  SET_IMAGE_TAG_CLICKED,
  UNSET_IMAGE_TAG_CLICKED,
  SET_VIDEO_TAG_CLICKED,
  UNSET_VIDEO_TAG_CLICKED,
  SET_AUDIO_TAG_CLICKED,
  UNSET_AUDIO_TAG_CLICKED,
  GET_NEW_COMMENTS,
  GET_NEW_COMMENTS_FAILURE,
  GET_NEW_COMMENTS_SUCCESS,
  RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX,
  RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX_SUCCESS,
  GET_USER_MENTIONS,
  GET_USER_MENTIONS_SUCCESS,
  GET_USER_MENTIONS_FAILURE,
  REMOVE_MENTION,
  CLEAR_MENTIONS,
  SET_IS_AUDIO_TAG_ACTIVE,
  UNSET_IS_AUDIO_TAG_ACTIVE,
  SET_IS_VIDEO_TAG_ACTIVE,
  UNSET_IS_VIDEO_TAG_ACTIVE,
  SET_IS_IMAGE_TAG_ACTIVE,
  UNSET_IS_IMAGE_TAG_ACTIVE,
} from '../constants/comment-types'

export default (state = initialState.comments, action) => {
  switch (action.type) {

    case SHOW_COMMENT:
      return {
        ...state,
        show: true,
        itemSelected: {
          ...state.itemSelected,
          document: {
            ...state.itemSelected.document,
            pdfCarouselIndex: 1
          }
        },
        fromKeyCollection: action.payload.fromKeyCollection,
        focusDescription: action.payload.focusDescription
      }

    case HIDE_COMMENT:
      return {
        ...state,
        show: false,
        fromKeyCollection: null,
        focusDescription: false,
        isPdfTagActive: false
      }

    case COMMENT_EMPTY:
      return {
        ...state,
        show: false,
        data: [],
        isCreating: false,
        isCommentDetermined: null,
        userDefaultComments: [],
        showCommentList: false,
        versionsShowCompare: false,
        itemSelectedFetching: false,
        itemSelected: {},
        itemVersions: [],
        isFetching: false,
        showVersions: false,
        focusDescription: false,
        pdfCarouselIndex: 1,
        previousPdfCarouselIndex: {
          index: 1,
          isSettingPrevious: false
        },
        isPdfTagActive: false

      }

    case GET_COMMENT:
      return {
        ...state,
        itemSelectedFetching: action.payload.itemSelectedFetching,
        isPdfTagActive: false
      }

    case GET_COMMENT_SUCCESS:
      return {
        ...state,
        itemSelected: {
          ...action.payload,
          document: {
            ...action.payload.document,
            // documentPages: state.pdfCarouselIndex === 1 ? action.payload.document.documentPages : state.itemSelected.document.documentPages,
            documentPages: action.payload.document.documentPages
          }
        },
        itemSelectedFetching: false,
        // item: action.payload.item,
        itemVersions: action.payload.versions,
        pdfCarouselIndex: 1,
        previousPdfCarouselIndex: {
          index: 1,
          isSettingPrevious: false
        },
      }

    case UPDATE_COMMENT_DART:
      return {
        ...state,
        // itemSelected: action.payload,
        itemSelected: {
          ...state.itemSelected,
          document: {
            ...state.itemSelected.document,
            ...action.payload
          }
        },
        loadingStatusAsset: action.payload.loadingStatusAsset,
        loadingDescription: action.payload.loadingDescription,
        loadingItemsMedia: action.payload.loadingItemsMedia
      }

    case LOADING_COMMENT_DART:
      return {
        ...state,
        loadingStatusAsset: action.payload.loadingStatusAsset,
        loadingDescription: action.payload.loadingDescription,
        loadingItemsMedia: action.payload.loadingItemsMedia
      }


    case LOADING_COMMENT_DART_ERROR:
      return {
        ...state,
        loadingStatusAsset: false,
        loadingDescription: false,
        loadingItemsMedia: null
      }

    case GET_COMMENT_FAILURE:
      return {
        ...state,
        itemSelected: {},
        itemSelectedFetching: false,
        pdfCarouselIndex: 1,
        previousPdfCarouselIndex: {
          index: 1,
          isSettingPrevious: false
        },
        // item: {}
      }

    case GET_COMMENTS:
      return {
        ...state,
        isFetching: action.payload.isFetching
      }

    case GET_COMMENTS_SUCCESS:
      return {
        ...state,
        headers: action.headers,
        data: [...state.data, ...action.payload],
        isFetching: false,
        lastCommentsPage: action.page
      }

    case CLEAR_LAST_COMMENTS: {
      return {
        ...state,
        headers: {},
        data: [],
        isFetching: false,
        lastCommentsPage: 1
      }

    }
    case GET_COMMENTS_FAILURE:
      return {
        ...state,
        isFetching: false
      }

    case ADD_COMMENT:
      return {
        ...state,
        isCreating: true
      }

    case ADD_COMMENT_SUCCESS:
      return {
        ...state,
        isCreating: false,
        itemSelected: {
          ...state.itemSelected,
          comments: [
            ...state.itemSelected.comments.map(r => {
              return {
                ...r,
              }
            }),
            {
              ...action.payload,
            }
          ]
        }
      }

    case ADD_COMMENT_FAILURE:
      return {
        ...state,
        isCreating: false
      }

    case SHOW_LIST_COMMENTS:
      return {
        ...state,
        showCommentList: true
      }

    case HIDE_LIST_COMMENTS:
      return {
        ...state,
        showCommentList: false
      }

    case DELETE_COMMENT:
      return {
        ...state,
        isDeleting: true
      }

    case DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        isDeleting: false,
        itemSelected: {
          ...state.itemSelected,
          comments: state.itemSelected.comments.filter(r => r._id !== action.payload)
        },
        data: state.data.filter(r => r._id !== action.payload)
      }

    case DELETE_COMMENT_FAILURE:
      return {
        ...state,
        isDeleting: false
      }

    case UPDATE_COMMENT_SUCCESS:
      return {
        ...state,
        itemSelected: {
          ...state.itemSelected,
          comments: state.itemSelected.comments.map(r => {
            if (r._id.toString() !== action.payload.commentId) {
              return r
            }
            else return { ...r, comment: action.payload.comment, mentions: action.payload.mentions, attachedFile: action.payload.attachedFile }
          })
        },
        // data: state.data.filter(r => r._id !== action.payload)
      }

    case SUCCESS_COMMENT_DETERMINED:
      return {
        ...state,
        userDefaultComments: action.payload
      }

    case SAVE_COMMENT_DETERMINED:
      return {
        ...state,
        isCommentDetermined: false,
        isLoadingCommentText: true
      }

    case SAVE_COMMENT_DETERMINED_SUCCESS:
      return {
        ...state,
        isCommentDetermined: true,
        isLoadingCommentText: false,
        userDefaultComments: [
          ...state.userDefaultComments,
          action.payload
        ]
      }

    case SAVE_COMMENT_DETERMINED_FAILURE:
      return {
        ...state,
        isCommentDetermined: false,
        isLoadingCommentText: false,
      }

    case DELETE_COMMENT_DETERMINED:
      return {
        ...state,
        isDeleteCommentDetermined: !state.isDeleteCommentDetermined
      }

    case DELETE_COMMENT_DETERMINED_SUCCESS:
      return {
        ...state,
        isDeleteCommentDetermined: true,
        userDefaultComments: [...state.userDefaultComments.filter(r => r._id !== action.payload.id)]
      }

    case SHOW_BUTTON_COMMENTS:
      return {
        ...state,
        showBtnComment: true,
      }

    case HIDE_BUTTON_COMMENTS:
      return {
        ...state,
        showBtnComment: false
      }

    case SEARCH_COMMENTS:
      return {
        ...state,
        isSearching: true
      }

    case SEARCH_COMMENTS_SUCCESS:
      return {
        ...state,
        isSearching: false,
        searchText: action.payload,
        itemSelected: {
          ...state.itemSelected,
          comments: [
            ...state.itemSelected.comments.map(r => {
              return {
                ...r,
                isCommentFound: r.comment.includes(action.payload) || r.user_creator.name.includes(action.payload.replace(/\b\w/g, l => l.toUpperCase()))
              }
            })
          ]
        }
      }
    case SEARCH_COMMENTS_CLEAR:
      return {
        ...state,
        itemSelected: {
          ...state.itemSelected,
          comments: [
            ...state.itemSelected.comments.map(r => {
              return {
                ...r,
                isCommentFound: false,
                isHighlight: false
              }
            })
          ]
        }
      }

    case SHOW_COMPARE_VERSIONS:
      return {
        ...state,
        versionsShowCompare: true
      }

    case HIDE_COMPARE_VERSIONS:
      return {
        ...state,
        versionsShowCompare: false
      }

    case SET_VERSIONS_COMPARE:
      return {
        ...state,
        versionsToCompare: action.payload.versionsToCompare,
        allVersions: action.payload.allVersions,
      }

    case SET_IS_EMPTY_COMPARE_DATA:
      return {
        ...state,
        isEmptyCompareData: action.payload.isEmptyCompareData,
      }

    case SHOW_VERSIONS:
      return {
        ...state,
        showVersions: true
      }

    case HIDE_VERSIONS:
      return {
        ...state,
        showVersions: false
      }

    case DELETE_VERSIONS:
      return {
        ...state,
        isDeleVersions: true
      }

    case DELETE_VERSIONS_SUCCESS:
      // console.log(state)
      return {
        ...state,
        itemSelected: {
          ...state.itemSelected,
          versions: [...state.itemVersions.filter(r => r._id !== action.payload.id)]
        },
        itemVersions: [...state.itemVersions.filter(r => r._id !== action.payload.id)]
      }

    case SET_QTY_VERSIONS:
      return {
        ...state,
        qtyVersions: action.payload.qtyVersions,
      }

    case SHOW_BUTTON_EMOJI:
      return {
        ...state,
        emoji: true
      }

    case HIDE_BUTTON_EMOJI:
      return {
        ...state,
        emoji: false
      }

    case SET_SOCKET_COMMENT_SCROLL:
      return {
        ...state,
        socketCommentScroll: action.payload.socketCommentScroll,
      }

    case RESET_STATUS_ASSET:
      return {
        ...state,
        itemSelected: {
          ...state.itemSelected,

          document: {
            ...state.itemSelected.document,
            statusAsset: null
          }

        }
      }

    case CLEAR_FOCUS_DESCRIPTION:
      return {
        ...state,
        focusDescription: false
      }

    case GET_USERS_TO_COMMENT:
      return {
        ...state,
        isFetchingUsersToComment: true
      }


    case GET_USERS_TO_COMMENT_SUCCESS:
      const { adminUsersToComment, operatorsUsersToComment } = action.payload
      return {
        ...state,
        isFetchingUsersToComment: false,
        adminUsersToComment: adminUsersToComment,
        operatorsUsersToComment: operatorsUsersToComment,
        errorUserToComment: null
      }
    case GET_USERS_TO_COMMENT_FAILURE:
      const { err } = action.payload
      return {
        ...state,
        isFetchingUsersToComment: false,
        adminUsersToComment: [],
        operatorsUsersToComment: [],
        errorUserToComment: err

      }
    case CLEAN_USERS_TO_COMMENT:
      return {
        ...state,
        isFetchingUsersToComment: false,
        adminUsersToComment: [],
        operatorsUsersToComment: [],
        errorUserToComment: null

      }
    case SET_IS_DOING_A_COMMENT_WITH_FILE:
      return {
        ...state,
        isDoingACommentWithFile: true
      }
    case UNSET_IS_DOING_A_COMMENT_WITH_FILE:
      return {
        ...state,
        isDoingACommentWithFile: false
      }

    case SET_PDF_CARROUSEL_INDEX:
      return {
        ...state,
        previousPdfCarouselIndex: {
          ...state.previousPdfCarouselIndex,
          index: state.pdfCarouselIndex
        },
        pdfCarouselIndex: Number(action.payload.index)
      }
    case GET_PDF_PAGES:
      return {
        ...state,
        isFetchingPages: action.payload.isFetching
      }

    case GET_PDF_PAGES_SUCCESS:
      const newDocumentPages = [...state.itemSelected.document.documentPages, ...action.payload.documentPages]
      return {
        ...state,
        headers: action.headers,
        itemSelected: {
          ...state.itemSelected,
          document: {
            ...state.itemSelected.document,
            totalDocumentPages: action.payload.totalDocumentPages,
            documentPages: newDocumentPages.filter((item, pos) => {
              return newDocumentPages.indexOf(item) === pos;
            }),
          }
        },
        isFetchingPages: false,
      }

    case GET_PDF_PAGES_FAILURE:
      return {
        ...state,
        isFetchingPages: false
      }
    case SET_IS_PDF_TAG_ACTIVE:
      return {
        ...state,
        isPdfTagActive: true
      }
    case UNSET_IS_PDF_TAG_ACTIVE:
      return {
        ...state,
        isPdfTagActive: false
      }

    case SET_PDF_TAG_CLICKED:
      return {
        ...state,
        // isPdfTagClicked: true,
        // pdfCarouselIndex: Number(action.payload.index)
        pdfTagClicked: { isClicked: true, newPdfCarouselIndex: Number(action.payload.index) },
      }
    case SET_IMAGE_TAG_CLICKED:
      return {
        ...state,
        imageTagClicked: {isClicked: true, index: Number(action.payload.index), pointX: Number(action.payload.pointX), pointY: Number(action.payload.pointY)}
      }
    case SET_VIDEO_TAG_CLICKED:
      return {
        ...state,
        videoTagClicked: {isClicked: true, time: Number(action.payload.time), version: Number(action.payload.version)}
      }
    case SET_AUDIO_TAG_CLICKED:
      return {
        ...state,
        audioTagClicked: {isClicked: true, time: Number(action.payload.time), version: Number(action.payload.version)}
      }
    case UNSET_PDF_TAG_CLICKED:
      return {
        ...state,
        pdfTagClicked: { isClicked: false, newPdfCarouselIndex: null },
      }
    case UNSET_IMAGE_TAG_CLICKED:
      return {
        ...state,
        imageTagClicked: { isClicked: false, index: null, pointX: null, pointY: null },
      }
    case UNSET_VIDEO_TAG_CLICKED:
      return {
        ...state,
        videoTagClicked: { isClicked: false, time: null, version: null },
      }
    case UNSET_AUDIO_TAG_CLICKED:
      return {
        ...state,
        audioTagClicked: { isClicked: false, time: null, version: null },
      }
    case GET_NEW_COMMENTS:
      return {
        ...state,
        isFetching: false

      }
    case GET_NEW_COMMENTS_SUCCESS:
      return {
        ...state,
        itemSelected: {
          // ...action.payload,
          ...state.itemSelected,
          comments: action.payload.comments
        },
        // itemSelectedFetching: false,
        // itemVersions: action.payload.versions,
        // pdfCarouselIndex: 1
      }

    case GET_NEW_COMMENTS_FAILURE:
      return {
        ...state,
        isFetching: false
      }

    case RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX:
      return {
        ...state,

        pdfCarouselIndex: state.previousPdfCarouselIndex.index,
        previousPdfCarouselIndex: {
          ...state.previousPdfCarouselIndex,
          isSettingPrevious: true
        },

      }

    case RESTORE_PREVIOUS_PDF_CARROUSEL_INDEX_SUCCESS:

      return {
        ...state,
        previousPdfCarouselIndex: {
          ...state.previousPdfCarouselIndex,
          isSettingPrevious: false
        }
      }

    case GET_USER_MENTIONS:

      return {
        ...state,
        userMentions: {
          ...state.userMentions,
          isFetchingMetions: true
        }

      }

    case GET_USER_MENTIONS_FAILURE:

      return {
        ...state,
        userMentions: {
          ...state.userMentions,
          mentions: [],
          isFetchingMetions: false
        }

      }

    case GET_USER_MENTIONS_SUCCESS:
      const { mentions } = action.payload
      return {
        ...state,
        userMentions: {
          ...state.userMentions,
          mentions: mentions,
          isFetchingMetions: false
        }

      }
    case REMOVE_MENTION:
      const { commentId } = action.payload
      return {

        ...state,
        userMentions: {
          ...state.userMentions,
          mentions: state.userMentions.mentions.filter(comment => comment.commentId !== commentId),

        }

      }

    case CLEAR_MENTIONS: {

      return {

        ...state,
        userMentions: {
          mentions: [],
          isFetchingMetions: false,
          isSettingCommentAsSeen: false
        }
      }
    }

    case SET_IS_AUDIO_TAG_ACTIVE:
      return {
        ...state,
        isAudioTagActive: true,
        audioTime: action.payload.audioTime
      }

    case UNSET_IS_AUDIO_TAG_ACTIVE:
      return {
        ...state,
        isAudioTagActive: false
      }

    case SET_IS_VIDEO_TAG_ACTIVE:
      return {
        ...state,
        isVideoTagActive: true,
        videoTime: action.payload.videoTime
      }

    case UNSET_IS_VIDEO_TAG_ACTIVE:
      return {
        ...state,
        isVideoTagActive: false,
        videoTime: null
      }
    
    case SET_IS_IMAGE_TAG_ACTIVE:
      return {
        ...state,
        isImageTagActive: true,
        imageTagXPer: action.payload.imageTagXPer,
        imageTagYPer: action.payload.imageTagYPer,
        imageTagWidth: action.payload.imageTagWidth,
        imageTagHeight: action.payload.imageTagHeight,
        imagePoint: action.payload.imagePoint,
      }

    case UNSET_IS_IMAGE_TAG_ACTIVE:
      return {
        ...state,
        isImageTagActive: false
      }

    default: return { ...state }
  }


}
